import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import { Box } from 'grommet';

import { parseTagFeatures } from '../../lib/product';
import ComingSoonBadge from '../Badges/ComingSoonBadge';
import NewBadge from '../Badges/NewBadge';
import DunkinBadge from '../Badges/DunkinBadge';
import MadewellBadge from '../Badges/MadewellBadge';
import BarbieBadge from '../Badges/BarbieBadge';
import ColorOfTheYearBadge from '../Badges/ColorOfTheYearBadge';
import BestWallpaperBadge from '../Badges/BestWallpaperBadge';
import PorscheBadge from '../Badges/PorscheBadge';
import SmartLink from '../SmartLink';

const ProductBadges = ({ tags, size, product, ...rest }) => {
  const tagFeatures = useMemo(() => parseTagFeatures(tags), [tags]);
  if (Object.keys(tagFeatures).length === 0) {
    return null;
  }
  return (
    <SmartLink to={product ? `/products/${product.handle}` : undefined}>
      <Box
        style={{ pointerEvents: 'none' }}
        width={{
          max: size
            ? size
            : tagFeatures.partnership
            ? tagFeatures.madewell
              ? '75px'
              : '65px'
            : '85px',
        }}
        height={{
          max: size
            ? size
            : tagFeatures.partnership
            ? tagFeatures.madewell
              ? '75px'
              : '65px'
            : '85px',
        }}
        margin={{ right: '20px' }}
        {...rest}
      >
        {tagFeatures.comingSoon && <ComingSoonBadge width="100%" />}
        {tagFeatures.dunkin && <DunkinBadge width="100%" />}
        {tagFeatures.barbie && <BarbieBadge width="100%" />}
        {tagFeatures.porsche && <PorscheBadge width="60%" />}
        {tagFeatures.isNew && <NewBadge size="40px" color="brand" />}
        {tagFeatures.bestWallpaper && (
          <BestWallpaperBadge size="100%" color="brand" />
        )}
        {tagFeatures.bestWallpaper2023 && (
          <BestWallpaperBadge year="2023" size="100%" color="brand" />
        )}
        {tagFeatures.colorOfTheYear && (
          <ColorOfTheYearBadge width="100%" color="brand" />
        )}
        {tagFeatures.madewell && (
          <MadewellBadge
            style={{ width: '100%', height: '100%' }}
            color="black"
          />
        )}
      </Box>
    </SmartLink>
  );
};

ProductBadges.propTypes = {
  tags: PropTypes.array,
  size: PropTypes.string,
  product: PropTypes.object,
};

export default memo(ProductBadges);
